import { useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";

import { ClientCard } from "@components/Cards";
import { InactivityThresholdCard } from "@components/Cards/InactivityThresholdCard/InactivityThresholdCard";
import { WhitelistedDomainsCard } from "@components/Cards/WhitelistedDomainsCard/WhitelistedDomainsCard";

import { Box } from "@design-system/Box/Box";

import { routes } from "@pages/routes";

export const Client = () => {
  const { clientId } = useTypedParams(routes.portal.clients.client);
  const navigate = useNavigate();

  const handleDeleteSuccess = () => {
    navigate(routes.portal.clients.$path(), {
      viewTransition: true,
      replace: true,
    });
  };

  const handleUpdateClientSuccess = () => {
    navigate(routes.portal.clients.$path(), {
      viewTransition: true,
    });
  };

  return (
    <Box direction="column" gap={8} fullStretch>
      <ClientCard
        clientId={clientId}
        onDeleteSuccess={handleDeleteSuccess}
        onUpdateClientSuccess={handleUpdateClientSuccess}
      />
      <WhitelistedDomainsCard clientId={clientId} />
      <InactivityThresholdCard clientId={clientId} />
    </Box>
  );
};
